<sd-component-wrapper [content]="componentWrapper">
  <ng-container sd-component-wrapper-component>
    <form novalidate [formGroup]="formGroup">
      <div class="d-flex c__form-row">
        <div class="c__form-item">
          <sd-form
            autocomplete
            formControlName="autocomplete"
            [properties]="['term']"
            [clearAfterSelectElement]="false"
            [elements]="autocompleteElements"
            [placeholder]="'repairability.search.placeholder' | translate"
            [minLength]="2"
            (inputChanged)="autocomplete($event)"
          >
            <ng-container sd-message>
              <sd-form-error
                errorKey="minlength"
                [errorLabel]="'repairability.search.errors.minLength' | translate"
                [control]="formGroup.get('autocomplete')"
              />
              @if (productNotFound && formGroup.get('autocomplete').valid) {
                <p class="is-error is-caption">
                  {{ 'repairability.search.errors.notFound' | translate }}
                </p>
              }
            </ng-container>
          </sd-form>
        </div>
        <div class="c__actions">
          <button sd-button (click)="search()" type="submit" (keydown.enter)="search()">
            <span> {{ 'repairability.search.button' | translate }}</span>
          </button>
        </div>
      </div>
    </form>
    <div class="c__how-to-find">
      <a class="has-icon d-flex align-items-center is-caption" (click)="openModalRef()">
        <sd-icon name="icon-help" [size]="iconSize.xs" />
        {{ 'accessory.search.findMyAss' | translate }}
      </a>
    </div>
    @if (product) {
      <sd-border-wrapper [attr.data-background]="'themes-very-light'" [hasBorder]="false">
        <div class="row">
          <div class="col-24 col-l-12 is-product-ref">
            <sd-product-customer
              [indexFollow]="product?.indexFollow"
              [titleLevel]="2"
              [hasNoActions]="true"
              [isReadOnly]="true"
              [productInfo]="{ media: productImage, title: product.name, code: product.commercialCode }"
            />
          </div>
          <div class="col-24 col-l-12 is-product-status">
            @switch (product.reparabilityIncluded) {
              @case (repairabilityEnum.YES) {
                <sd-title [isDescription]="true" customClass="is-bold is-body-l" [attr.data-color]="'success-base'">
                  {{ 'repairability.search.yes.title.' + product.repairabilityStatus | translate }}
                </sd-title>
                <sd-html
                  innerClass="is-body-s"
                  [html]="'repairability.search.yes.description.' + product.repairabilityStatus | translate"
                />
                <sd-link
                  [isButton]="true"
                  [isSmall]="true"
                  [link]="{ url: '/consumer-services/warranty-and-repairs/repairers' }"
                >
                  {{ 'repairability.search.link' | translate }}
                </sd-link>
              }
              @case (repairabilityEnum.NO) {
                <sd-title [isDescription]="true" customClass="is-bold is-body-l" [attr.data-color]="'error-base'">
                  {{ 'repairability.search.no.title.' + product.repairabilityStatus | translate }}
                </sd-title>
                <sd-html
                  innerClass="is-body-s"
                  [html]="'repairability.search.no.description.' + product.repairabilityStatus | translate"
                />
                <sd-link
                  [isButton]="true"
                  [isSmall]="true"
                  [link]="{ url: '/consumer-services/warranty-and-repairs/repairers' }"
                >
                  {{ 'repairability.search.link' | translate }}
                </sd-link>
              }
              @case (repairabilityEnum.NA) {
                <sd-title [isDescription]="true" customClass="is-bold is-body-l">
                  {{ 'repairability.search.tbd.title' | translate }}
                </sd-title>
                <sd-html
                  innerClass="is-body-s"
                  [html]="'repairability.search.tbd.description' | translate"
                />
                <sd-link
                  [isButton]="true"
                  [isSmall]="true"
                  [link]="{ url: '/consumer-services/warranty-and-repairs/repairers' }"
                >
                  {{ 'repairability.search.link' | translate }}
                </sd-link>
              }
            }
          </div>
        </div>
      </sd-border-wrapper>
    }
  </ng-container>
</sd-component-wrapper>

@defer (when isRefModalOpened) {
  <sd-modal-default
    [(isOpened)]="isRefModalOpened"
    [noPadding]="true"
    [modalTitleLevel]="4"
    [modalTitle]="'accessory.search.modal.title' | translate"
  >
    <div sd-modal-body>
      <div>{{ 'accessory.search.modal.text' | translate }}</div>
      <br />
      <div>{{ 'accessory.search.modal.example' | translate }}</div>
      <sd-banner [media]="{ url: urlImage }" style="max-width: 42.6rem; margin: 2rem auto 0" />
    </div>
  </sd-modal-default>
}
